export enum IScoreCardStatus {
  Active = 'Active',
  Closed = 'Closed'
}
